var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIonCartOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 17.7666C7.22018 17.7666 7.5 17.4728 7.5 17.1104C7.5 16.7479 7.22018 16.4541 6.875 16.4541C6.52982 16.4541 6.25 16.7479 6.25 17.1104C6.25 17.4728 6.52982 17.7666 6.875 17.7666Z",
    stroke: "#4E26A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 17.7666C15.9702 17.7666 16.25 17.4728 16.25 17.1104C16.25 16.7479 15.9702 16.4541 15.625 16.4541C15.2798 16.4541 15 16.7479 15 17.1104C15 17.4728 15.2798 17.7666 15.625 17.7666Z",
    stroke: "#4E26A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 3.3291H4.375L6.25 14.4854H16.25",
    stroke: "#4E26A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 11.8604H15.9937C16.066 11.8604 16.1361 11.8342 16.192 11.7861C16.2479 11.738 16.2862 11.671 16.3004 11.5966L17.4254 5.69037C17.4345 5.64275 17.4334 5.5936 17.4222 5.54648C17.4109 5.49935 17.3899 5.45543 17.3606 5.41788C17.3312 5.38033 17.2943 5.35008 17.2525 5.32932C17.2107 5.30857 17.165 5.29782 17.1187 5.29785H5",
    stroke: "#4E26A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonCartOutline);
export default __webpack_public_path__ + "static/media/ion_cart-outline.34aa0e912e2aa828c08ee3dd4d3fcc6b.svg";
export { ForwardRef as ReactComponent };